import React from 'react'

import Media from 'local_modules/Media'


const Image = ({ children, className, src, w, mw, h, mh, alt }) => (
  <Media mobile>
    {
      (isMobile) => (
        <Media retina>
          {
            (isRetina) => {
              const sizeW   = isMobile ? mw || w : w
              const sizeH   = isMobile ? mh || h : h
              const width   = isRetina ? sizeW * 2 : sizeW
              const height  = isRetina ? sizeH * 2 : sizeH
              const postfix = h ? `&h=${height}` : `&w=${width}`

              return typeof children === 'function'
                ? children(src + postfix, src, postfix)
                : (
                  <img
                    className={className}
                    src={src + postfix}
                    alt={alt}
                  />
                )
            }
          }
        </Media>
      )
    }
  </Media>
)


export default Image
